module.exports = __webpack_public_path__ + "static/media/fanball.2d3ef711.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/fanball.svg
// module id = 98
// module chunks = 0